import { faFileAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { getPatientOrders } from "../../actions/orderAction";
import BreadCrumb from "../../components/Breadcrumb";
import Loader from "../../components/Loader";
import Invoice from "../Order/Invoice";
import PatientOrderDetail from "./PatientOrderDetail";
import { formatDate } from "../../utils/helper";
const PatientOrder = () => {
  const orderHistoryList = useSelector(
    (state) => state.order.patientOrderHistoryList
  );

  const [showPopup, setShowPopup] = useState(false);
  const [activeID, setActiveId] = useState(0);
  const dispatch = useDispatch();
  const [showInvoice, setShowInvoice] = useState(false);
  const [activeInvoice, setActiveInvoice] = useState(null);
  const [items, setItems] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    dispatch(
      getPatientOrders(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  const setActive = (id, detail) => {
    setActiveId(id);
    setShowInvoice(true);
    setActiveInvoice(detail);
    // dispatch(
    //   getHistoryPrescriptionForPractitioner(id, () => {
    //     setShowPopup(true);
    //   })
    // );
  };

  const handleChange = (e) => {
    let searchTerm = e.target.value;

    let newList = items.filter(
      (x) =>
        x.patients.some((y) =>
          y.patientName.toLowerCase().includes(searchTerm.toLowerCase())
        ) ||
        x.subscriptions.some((y) =>
          y.subscriptionName.toLowerCase().includes(searchTerm.toLowerCase())
        ) ||
        x.products.some((y) =>
          y.productName.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );
    setFilteredList(newList);
  };

  useEffect(() => {
    if (orderHistoryList.length > 0) {
      let itemsForTable = [];
      orderHistoryList.forEach((element, i) => {
        let descriptionInfo = [];
        let practitionerList = [];
        let subscriptionList = [];
        let productList = [];
        let detailDescriptionInfo = {};
        element.InvoiceItems.forEach((item) => {
          if (item.DescriptionInfo) {
            if (item.INVI_Type == 1) {
              detailDescriptionInfo.invoiceType = 1;
              descriptionInfo.push({
                description: `Prescription from ${item.DescriptionInfo.practitioner_name}`,
              });
              practitionerList.push({
                practitionerName: item.DescriptionInfo.practitioner_name,
              });
            } else if (item.INVI_Type == 7) {
              descriptionInfo.push({
                description: `Subscription for ${item.DescriptionInfo.subscriptionName}`,
              });
              subscriptionList.push({
                subscriptionName: item.DescriptionInfo.subscriptionName,
              });
              detailDescriptionInfo.invoiceType = 7;
              detailDescriptionInfo.detailText = `Subscription for ${item.DescriptionInfo.subscriptionName}`;
            } else if (item.INVI_Type == 0) {
              detailDescriptionInfo.invoiceType = 1;
              descriptionInfo.push({
                description: item.DescriptionInfo.productName,
              });
              productList.push({
                productName: item.DescriptionInfo.productName,
              });
            }
          }
        });
        itemsForTable.push({
          invoiceId: element.INVC_ID,
          invoiceDate: formatDate(element.INVC_Date),
          invoicePrice: element.INVC_Price,
          description: descriptionInfo,
          practitioners: practitionerList,
          subscriptions: subscriptionList,
          index: i,
          detailDescriptionInfo: detailDescriptionInfo,
          products: productList,
        });
      });
      setItems(itemsForTable);
      setFilteredList(itemsForTable);
    }
  }, [orderHistoryList]);
  const columns = [
    {
      dataField: "invoiceDate",
      text: "Date Created",
      sort: true,
    },
    {
      dataField: "",
      text: "Item(s)",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return row.description.map((x, i) => {
          return (
            <div className="d-flex align-items-center justify-content-center">
              <p key={i} style={{ marginBottom: "5px" }}>
                {x.description}
              </p>
              <br />
            </div>
          );
        });
      },
    },
    {
      dataField: "invoiceId",
      text: "order#",
      sort: true,
    },
    {
      dataField: "",
      text: "Details",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => {
              setActive(row.invoiceId);
              setActiveInvoice(row.detailDescriptionInfo);
            }}
          />
        );
      },
    },
    {
      dataField: "invoicePrice",
      text: "Amount",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <p style={{ marginBottom: "0" }}>
            {(Math.round((row.invoicePrice / 100) * 100) / 100).toLocaleString(
              "en-US",
              {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                style: "currency",
                currency: "USD",
              }
            )}
          </p>
        );
      },
    },
  ];
  return (
    <div className="patients-page">
      {isLoading && <Loader />}
      <BreadCrumb pageName="Orders" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Orders</h3>
          <p className="page-desc">Below is a list of your completed orders.</p>
        </div>
      </div>
      {showInvoice ? (
        <Invoice
          invoiceId={activeID}
          backAction={setShowInvoice}
          activeInvoice={activeInvoice}
        />
      ) : (
        <div className="row mt-2">
          <div className="col-md-12">
            <h5 className="profile-title mb-2">Order History</h5>
            {showPopup && (
              <PatientOrderDetail
                closePopup={() => setShowPopup(false)}
                prescriptionId={activeID}
                isRefill={false}
              />
            )}

            {items.length > 0 ? (
              <>
                <div className="row mt-1">
                  <div className="col-md-6">
                    <div className="form-group search">
                      <div>
                        <label htmlFor="search">
                          Search: (PRACTITIONER NAME)
                        </label>
                        <div className="input">
                          <input
                            name="search"
                            className="form-control"
                            id="search"
                            onChange={handleChange}
                            type="text"
                          ></input>
                        </div>
                      </div>
                      <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
                    </div>
                  </div>
                </div>
                <BootstrapTable
                  classes="react-bootstrap-table"
                  columns={columns}
                  keyField="invoiceId"
                  data={filteredList}
                  headerClasses="header-class"
                />
              </>
            ) : (
              <p className="page-desc">There are no orders at this time</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default PatientOrder;
